<script lang="ts" setup>

import { computed, useAppConfig } from '#imports';
import { toShortAddress } from '~/utils/helpers';

interface Props {
    owners: AppWTFNftOwnersList;
    params: RouteStateType;
    total: number;
}

const props = defineProps<Props>();

const emit = defineEmits<{
    (e: 'close-modal'): void;
    (e: 'update:queryParams', newParams: Partial<RouteStateType>): void;
}>();

const formattedOwnersList = computed(() => {
    return props.owners.map((owner) => {
        return {
            ...owner,
            value: owner.value.toLocaleString('ru-RU'),
            address: owner.address,
            shortAddress: toShortAddress(owner.address)
        };
    });
});

type RouteStateType =
    Pick<AppPagination, 'page' | 'size'>;

const closeModal = () => {
    emit('close-modal');
};

const onChangeQueryParams = (values: Partial<RouteStateType>) => {
    const newParams = { ...props.params, ...values };
    emit('update:queryParams', newParams);
};

</script>

<template>
  <div class="modal-owners-info display-flex flex-column gap-20">
    <h1 class="display-800-accent"> Owners </h1>

    <div v-if="formattedOwnersList.length > 0"
         class="display-flex flex-column gap-12">

      <div v-for="(owner, index) in formattedOwnersList"
           :key="index"
           class="owner-row display-flex justify-between align-items-center">
        <div class=" align-items-center display-flex gap-12">
          <!--          Todo: функционала отображения списка owners с картинками ещё нет -->
          <!--          <div :style="{ 'background-image': `url(${owner.img})` }"-->
          <!--               class="owner-avatar"></div>-->
          <!--          <ImgMain :src="owner.img"-->
          <!--                     class="owner-avatar" />-->
          <div class="display-flex flex-column gap-2">
            <!--            TODO: функционала отображения списка owners с никнеймами ещё нет -->
            <!--            <p class="compact-500-accent">{{ owner.name }}</p>-->
            <!--            <p class="compact-500-accent color-text-grey">{{ owner.address }}</p>-->

            <NuxtLink :to="`/profile/${owner.address}`"
                      class="compact-500-accent color-text-grey"
                      @click="closeModal"
            >
              {{ owner.shortAddress }}
            </NuxtLink>

          </div>
        </div>
        <div class="compact-500-accent-numeric"> {{ owner.value }} items</div>
      </div>

    </div>

    <div v-if="formattedOwnersList.length == 0"
         class="display-flex flex-column align-items-center justify-center gap-12 pad-center">
      <div class="empty-circle display-flex align-items-center justify-center">
        <IconMain icon="air"
                  :size="28"
        />
      </div>
      <div class="display-flex flex-column align-items-center justify-center">
        <p class="compact-500-accent">
          No owners found
        </p>

      </div>
    </div>
    <Suspense>
      <LazyPagination class="width-full display-flex justify-center"
                      :page="params.page"
                      :size="params.size"
                      :total="total"
                      :visible-items="10"
                      @on-page="(page: number) => onChangeQueryParams({ page })"
      />
      <template #fallback>
        <div class="width-full display-flex justify-center gap-8">
          <LoaderSkeleton :height="30"
                          :width="30" />
          <LoaderSkeleton :height="30"
                          :width="30" />
          <LoaderSkeleton :height="30"
                          :width="30" />
        </div>
      </template>
    </Suspense>
  </div>
</template>

<style lang="scss" scoped>
.owner-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-size: cover;
}

.owner-row {
  height: 56px;
}

.pagination {
  margin-top: 24px;
}
</style>
